import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Lib} from "../../../libs/Lib";
import {Memoizee} from "../../decorators/memoizee-decorator";

@Component({
    selector: 'app-image-loader',
    templateUrl: './image-loader.component.html',
    styleUrls: ['./image-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class ImageLoaderComponent implements OnInit {

    // tslint:disable-next-line
    @Input('style')
    _style: any = {};

    @Input()
    defaultImage = '';

    @Input()
    circle = false;

    @Input()
    images: Array<string> = [];

    public imageRetries = 0;

    constructor(public cdr: ChangeDetectorRef) {
    }

    ngOnInit() {
    }      

    public getImageUrl() {
        if (!this.images)
            return this.defaultImage;
        if (this.images.length === 0)
            return this.defaultImage;
        if (this.images[this.imageRetries] === undefined)
            return this.defaultImage;
        const url = this.images[this.imageRetries] + (Lib.DevMode() ? '?random=xyz' : `?random=' ${Math.random()}`);
        return url;
    }

    public onImageLoaded() {
        this.cdr.detach();
    }

    public onImageError() {
        this.imageRetries++;
    }

    public reloadImage() {
        this.imageRetries = 0;
        this.cdr.reattach();
    }
}


